<mat-progress-bar [mode]="mode" [value]="value"></mat-progress-bar>
